module.exports = __webpack_public_path__ + "img/bottomBtnsBox.82d5fcb0.png";